<template>
    <div>
        <b-card-header>
            <span class="h5"> Cronograma Recebimento </span>
        </b-card-header>
            <app-tabela
                idTabela="tblCronogramaRecebimento"
                :itens="cronogramaRecebimento"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false">
                <template slot="botoes">
                    <b-button-group class="float-right">
                        <btn-inserir-cronograma-recebimento
                            v-if="$temAcessoView('CONV-REC-01')"
                            :convenio="convenio"
                            @atualizarLista="atualizarLista()">
                        </btn-inserir-cronograma-recebimento>
                    </b-button-group>
                </template>
                <template slot="nuValorRecebimento" slot-scope="data">
                    <p class="text-right m-0">
                        {{ data.nuValorRecebimento | currency }}
                    </p>
                </template>
                <template slot="dtMesAno" slot-scope="data">
                    <p class="text-left m-0">
                        {{ data.dtMesAno ? $moment(data.dtMesAno).format('MM/YYYY') : '' }}
                    </p>
                </template>
                <template slot="acoes" slot-scope="data">
                    <btn-atualizar-cronograma-recebimento
                        class="text-danger float-left mr-1"
                        v-if="$temAcessoView('CONV-REC-02')"
                        :convenio="convenio"
                        :cronogramaRecebimento="data"
                        @atualizarLista="atualizarLista()">
                    </btn-atualizar-cronograma-recebimento>
                    <btn-excluir-cronograma-recebimento
                        class="text-danger float-left mr-1"
                        v-if="$temAcessoView('CONV-REC-02')"
                        :convenio="convenio"
                        :cronogramaRecebimento="data"
                        @atualizarLista="atualizarLista()"
                    ></btn-excluir-cronograma-recebimento>
                </template>
            </app-tabela>

    </div>
</template>

<script>
import ConveniosServicos from '../ConveniosServicos'
import BtnCronogramaRecebimento from "../cadastro/BtnCronogramaRecebimento.vue"
import BtnInserirCronogramaRecebimento from '../cadastro/cronogramaRecebimento/BtnInserirCronogramaRecebimento.vue'
import BtnAtualizarCronogramaRecebimento from '../cadastro/cronogramaRecebimento/BtnAtualizarCronogramaRecebimento.vue'
import BtnExcluirCronogramaRecebimento from '../cadastro/cronogramaRecebimento/BtnExcluirCronogramaRecebimento.vue'


export default {
    props: {
        convenio: {
            type: Object,
            default: () => ({})
        }
    },

    components: {
        BtnCronogramaRecebimento,
        BtnInserirCronogramaRecebimento,
        BtnAtualizarCronogramaRecebimento,
        BtnExcluirCronogramaRecebimento,
    },

    data() {
        return {
            cronogramaRecebimento: [],
            itensSelecionados: [],
            erros: [],
            campos: [
                {
                    key: 'vcDescricao',
                    label: 'Descrição',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'nuParcela',
                    label: 'Parcela',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'dtMesAno',
                    label: 'Mês\\Ano',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'nuValorRecebimento',
                    label: 'Valor',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ],
            itensPorPagina: 5
        }
    },

    methods: {

        atualizarLista(){
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterPorId(this.convenio.idConvenio)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.cronogramaRecebimento = response.data.cronogramaRecebimento
                        this.$emit('atualizarDadosConvenio')
                    }
                    else{
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

    },

    computed: {
        mostrarTabela() {
            return false
        },
    },

    watch:{
        convenio(){
            if(this.convenio){
                this.cronogramaRecebimento = this.convenio.cronogramaRecebimento
            }
        }
    },
}
</script>
